(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["climate_smart"] && !Shopify.designMode) return;
  try {
    
      window.addEventListener('load', function() { 
          // Auto fill from LS
          var zipCodeFromLS = localStorage.getItem('zipcode') || localStorage.getItem('_glood_zipcode');
          $('.climate-smart-gps__form input[name=zipcode]').val(zipCodeFromLS);
          
          $('.climate-smart-gps__form').submit(function(e) {
              e.preventDefault();
              e.stopPropagation();
              var formData = new FormData(e.target);
              var zipCode = formData.get('zipcode');
              if (zipCode) {
                  localStorage.setItem('zipcode', zipCode);
                  localStorage.setItem('_glood_zipcode', zipCode);
              }
              window.location.href = "/pages/personalized-for-you";
  
          });
      });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderScroll extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('header');
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if(!!window.IntersectionObserver){
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });
        observer.observe(this.header);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('header-hidden', 'header-sticky', 'scroll');
      this.closeInnerItems();
    }

    reveal() {
      this.header.classList.add('header-sticky', 'animate', 'scroll');
      this.header.classList.remove('header-hidden');
    }

    reset() {
      this.header.classList.remove('header-hidden', 'header-sticky', 'animate', 'scroll');
    }

    closeInnerItems() {
      this.innerItems = this.innerItems || this.header.querySelectorAll('details-disclosure,details-modal');
      this.innerItems.forEach(item => item.close());
    }
  }

  customElements.define('header-scroll', HeaderScroll);

  } catch(e) { console.error(e); }
})();
})();
